/*Contacts*/
import ContactCard from "./ContactCard";
import BtnPrimary from "../ui/BtnPrimary";
import BtnSecondary from "../ui/BtnSecondary";
import { Mail } from "lucide-react";

function Contacts({ contacts }) {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-inner">
        <div>
          <div className="section-eyebrow">Let&apos;s Connect</div>

          <h2 className="contact-title">
            Open to new{" "}
            <span style={{ color: "var(--purple2)" }}>opportunities</span>
          </h2>

          <p className="contact-desc">
            I have professional experience building enterprise applications with
            Java and modern backend technologies, while continuously expanding
            my expertise across React, Node.js and Cloud technologies.
          </p>

          <div className="contact-actions">
            <BtnPrimary
              text="Send an Email"
              href="mailto:rm45555@gmail.com"
              icon={<Mail size={17} />}
            />

            <BtnSecondary
              text="LinkedIn"
              href="https://www.linkedin.com/in/ricardo-martins07/"
              icon={<i className="devicon-linkedin-plain"></i>}
            />
          </div>
        </div>

        <div className="contact-cards">
          {contacts.map((contact) => (
            <ContactCard key={contact.label} {...contact} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Contacts;
